module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Pictures#1-fefbcc0a71dc7331ed7ddd4fa8c4be0c.svg";